import { render } from "./whatSappComponent.vue?vue&type=template&id=2f58cdf2&scoped=true"
import script from "./whatSappComponent.vue?vue&type=script&lang=js"
export * from "./whatSappComponent.vue?vue&type=script&lang=js"

import "./whatSappComponent.vue?vue&type=style&index=0&id=2f58cdf2&scoped=true&lang=css"
import "./whatSappComponent.vue?vue&type=style&index=1&id=2f58cdf2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f58cdf2"]])

export default __exports__